/**
 * @generated SignedSource<<925310a029b34ecb9cbb163a66b69a46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNewSourcesOfFundsQuery$variables = {
  skipDepositInformation: boolean;
};
export type useNewSourcesOfFundsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"useNewSourcesOfFundsFragment">;
  };
};
export type useNewSourcesOfFundsQuery = {
  response: useNewSourcesOfFundsQuery$data;
  variables: useNewSourcesOfFundsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDepositInformation"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Amount",
  "kind": "LinkedField",
  "name": "availableBalance",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalance",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalanceFiat",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v12 = [
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assetOrFiatCurrency",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        (v9/*: any*/),
        (v2/*: any*/),
        (v10/*: any*/),
        (v1/*: any*/)
      ],
      "type": "TiersCurrency",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "symbol",
              "storageKey": null
            },
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ViewerAsset",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Node",
      "abstractKey": "__isNode"
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "ViewerEquity",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v4/*: any*/),
  (v6/*: any*/),
  (v13/*: any*/),
  (v11/*: any*/),
  (v10/*: any*/),
  (v2/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentMethodV2",
  "kind": "LinkedField",
  "name": "paymentMethod",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instantBuy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pickerData",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "use3ds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "institutionName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardLast4",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requires3dsDdc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiresAt",
              "storageKey": null
            }
          ],
          "type": "WorldpayCardPickerData",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountNumber",
              "storageKey": null
            }
          ],
          "type": "BankPickerDataV2",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethodFiatAccount",
              "kind": "LinkedField",
              "name": "fiatAccount",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "CoinbaseFiatAccountPickerData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v11/*: any*/),
    (v10/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentLimits",
      "kind": "LinkedField",
      "name": "limits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Amount",
          "kind": "LinkedField",
          "name": "remainingAvailableLimit",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "paymentMethodName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAllowance",
      "kind": "LinkedField",
      "name": "tradeCapabilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBuy",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryBuy",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNewSourcesOfFundsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "skipDepositInformation",
                  "variableName": "skipDepositInformation"
                }
              ],
              "kind": "FragmentSpread",
              "name": "useNewSourcesOfFundsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNewSourcesOfFundsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProperties",
            "kind": "LinkedField",
            "name": "userProperties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showInstantAchUx",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "supportedSourcesOfFunds",
                "value": [
                  "PAYMENT_METHOD",
                  "FIAT_WALLET",
                  "CRYPTO_ACCOUNT"
                ]
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "cbPaySourcesOfFunds",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Amount",
                    "kind": "LinkedField",
                    "name": "remainingAvailableLimit",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "CBPaySourceOfFundsCryptoAccount",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "type": "CBPaySourceOfFundsPaymentMethod",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v13/*: any*/),
                      (v11/*: any*/),
                      (v10/*: any*/),
                      {
                        "condition": "skipDepositInformation",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountDepositInformation",
                            "kind": "LinkedField",
                            "name": "depositInformation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDepositAllowed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "depositCurrency",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AccountDepositMethod",
                                "kind": "LinkedField",
                                "name": "availableDepositMethods",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AccountDepositMethodInformation",
                                    "kind": "LinkedField",
                                    "name": "depositInformation",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "key",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "type": "CBPaySourceOfFundsFiatWallet",
                "abstractKey": null
              }
            ],
            "storageKey": "cbPaySourcesOfFunds(supportedSourcesOfFunds:[\"PAYMENT_METHOD\",\"FIAT_WALLET\",\"CRYPTO_ACCOUNT\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountConnection",
            "kind": "LinkedField",
            "name": "accountsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "15395b50821a561a8036b1fc1c4cc680",
    "id": null,
    "metadata": {},
    "name": "useNewSourcesOfFundsQuery",
    "operationKind": "query",
    "text": "query useNewSourcesOfFundsQuery(\n  $skipDepositInformation: Boolean!\n) {\n  viewer {\n    ...useNewSourcesOfFundsFragment_4pQBtl\n    id\n  }\n}\n\nfragment getIsCountryAllowedAccountFragment on Account {\n  type\n}\n\nfragment getIsCountryAllowedFiatFragment on PaymentMethodV2 {\n  type\n  instantBuy\n  pickerData {\n    __typename\n    ... on WorldpayCardPickerData {\n      use3ds\n    }\n    ... on BankPickerDataV2 {\n      __typename\n    }\n  }\n}\n\nfragment readAccountBalanceFiatFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFragment on Account {\n  availableBalance {\n    currency\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      type\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCryptoAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  uuid\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on TiersCurrency {\n      name\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCryptoAccountsFragment on Account {\n  ...readCryptoAccountFragment\n}\n\nfragment readDepositInformationFragment on Account {\n  depositInformation {\n    isDepositAllowed\n    depositCurrency\n    availableDepositMethods {\n      isActive\n      type\n      depositInformation {\n        key\n        title\n        value\n      }\n    }\n  }\n}\n\nfragment readFiatWalletAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readAccountBalanceFragment\n  uuid\n  name\n  type\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      code\n      name\n      type\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readFiatWalletPaymentMethodFragment on PaymentMethodV2 {\n  uuid\n  name\n  type\n  currency\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n  }\n}\n\nfragment readFiatWalletsAccountFragment on Account {\n  ...readFiatWalletAccountFragment\n  uuid\n  type\n}\n\nfragment readFiatWalletsPaymentMethodFragment on PaymentMethodV2 {\n  ...readFiatWalletPaymentMethodFragment\n  uuid\n  type\n  pickerData {\n    __typename\n    ... on CoinbaseFiatAccountPickerData {\n      fiatAccount {\n        uuid\n        id\n      }\n    }\n  }\n}\n\nfragment readPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  uuid\n  type\n  paymentMethodName: name\n  currency\n  verified\n  tradeCapabilities {\n    allowBuy\n  }\n  pickerData {\n    __typename\n    ... on BankPickerDataV2 {\n      accountName\n      accountNumber\n    }\n    ... on WorldpayCardPickerData {\n      institutionName\n      bin\n      cardLast4\n      use3ds\n      requires3dsDdc\n      expiresAt\n    }\n    ... on CoinbaseFiatAccountPickerData {\n      __typename\n    }\n  }\n  limits {\n    remainingAvailableLimit {\n      currency\n      value\n    }\n    description\n  }\n}\n\nfragment readPaymentMethodsFragment on PaymentMethodV2 {\n  ...readPaymentMethodFragment\n  uuid\n  primaryBuy\n}\n\nfragment useNewSourcesOfFundsFragment_4pQBtl on Viewer {\n  ...useSourceOfFundsToCommonFormatRequiredData\n  cbPaySourcesOfFunds(supportedSourcesOfFunds: [\"PAYMENT_METHOD\", \"FIAT_WALLET\", \"CRYPTO_ACCOUNT\"]) {\n    __typename\n    ... on CBPaySourceOfFundsCryptoAccount {\n      account {\n        ...useParseSourcesOfFundsAccountFragment\n        id\n      }\n      remainingAvailableLimit {\n        value\n        currency\n      }\n    }\n    ... on CBPaySourceOfFundsPaymentMethod {\n      isEnabled\n      paymentMethod {\n        ...useParseSourcesOfFundsPaymentMethodFragment\n        pickerData {\n          __typename\n        }\n        id\n      }\n    }\n    ... on CBPaySourceOfFundsFiatWallet {\n      isEnabled\n      account {\n        ...useParseSourcesOfFundsAccountFragment\n        ...useParseSourcesOfFundsAccountDepositInformationFragment @skip(if: $skipDepositInformation)\n        id\n      }\n      paymentMethod {\n        ...useParseSourcesOfFundsPaymentMethodFragment\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...useParseSourcesOfFundsAccountFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useParseSourcesOfFundsAccountDepositInformationFragment on Account {\n  ...readDepositInformationFragment\n}\n\nfragment useParseSourcesOfFundsAccountFragment on Account {\n  ...getIsCountryAllowedAccountFragment\n  ...readCryptoAccountsFragment\n  ...readFiatWalletsAccountFragment\n}\n\nfragment useParseSourcesOfFundsPaymentMethodFragment on PaymentMethodV2 {\n  ...getIsCountryAllowedFiatFragment\n  ...readFiatWalletsPaymentMethodFragment\n  ...readPaymentMethodsFragment\n}\n\nfragment useSourceOfFundsToCommonFormatRequiredData on Viewer {\n  userProperties {\n    country {\n      code\n    }\n    showInstantAchUx\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aef734a6d9a8632cb1e5563cececa23d";

export default node;
